'use strict';

import React from 'react';

import PropTypes from 'prop-types';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import TermUtils from '@uw-it-sis/lib-react/lib/TermUtils';
import {isEmpty} from "@uw-it-sis/lib-react/lib/Utils";
import LinkBuilder from './LinkBuilder';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/**
 * Displays a Course Summary.
 */
const CourseSummary = (props) => {

    let courseSummary = props.courseSummary;

    // Build schedules terms
    let scheduledTerms = <span>Not currently offered</span>;
    if (courseSummary.scheduledTerms.length > 0) {
        let scheduledTermList = courseSummary.scheduledTerms.map((term, i) => {
            return (
                <li className="list-inline-item" key={i}>
                    {TermUtils.makeTermBadge(term, i)}
                </li>
            );
        });

        scheduledTerms = <ul className="list-inline mb-0">{scheduledTermList}</ul>;
    }

    //  Last offered term (only if the data exists and there is no scheduled term)
    //  NOTE: I don't think this is ever populated, also I don't know if this should be a badge.
    let lastOffered = undefined;
    if (courseSummary.lastOffered && courseSummary.scheduledTerms.length === 0) {
        /* Had to add keys in here to get rid of warnings ... https://fb.me/react-warning-keys */
        lastOffered = [<dt className="col-sm-4" key={1}>Last Offered</dt>, <dd className="col-sm-8" key={2}>{courseSummary.lastOffered}</dd>];
    }

    //  Build projected terms
    let projectedTerms = <span>Check with the department or your adviser for more information about this course.</span>;
    if (courseSummary.termsOffered.length > 0) {
        projectedTerms = <span>{courseSummary.termsOffered.join(", ")}</span>
    }

    let authenticated = appStore.isAuthenticated();

    //  Build requisites
    let requisites = <span>None</span>;
    if (courseSummary.requisites.length > 0) {
        requisites = courseSummary.requisites.map(function (req, i) {
            return <span key={i}>{LinkBuilder.linkify(req, authenticated)}</span>;
        });
    }

    let recommendedPrep = null;
    if (!isEmpty(courseSummary.recommendedPrep)) {

        recommendedPrep = <>
            <dt className="col-sm-4">Recommended Prep</dt>
            <dd className="col-sm-8"><span>{LinkBuilder.linkify(courseSummary.recommendedPrep, authenticated)}</span></dd>
        </>;
    }

    return (
        <Row className="course-summary">
            <Col xs={12}>
                <dl className="row description-term-colon">
                    <dt className="col-sm-4">Scheduled for</dt>
                    <dd className="col-sm-8">{scheduledTerms}</dd>

                    {lastOffered}

                    <dt className="col-sm-4">Projected for</dt>
                    <dd className="col-sm-8">{projectedTerms}</dd>

                    <dt className="col-sm-4">Course prequisites</dt>
                    <dd className="col-sm-8">{requisites}</dd>

                    {recommendedPrep}
                </dl>
            </Col>
        </Row>
    );
};

CourseSummary.propTypes = {
    courseSummary: PropTypes.object.isRequired
};

export default CourseSummary;